import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import makeMainRoutes from './components/Routes/routes';


const routes = makeMainRoutes();

ReactDOM.render(
  routes,
  document.getElementById('root')
);